import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { PaginatedParams, PaginatedResponse } from 'services/api/types'
import { axios } from 'lib'
import { OrdersCarriers } from 'modules/orders/types'

const loadOrderCarriers = (
  data: PaginatedParams
): PaginatedResponse<OrdersCarriers> => {
  const { page = 1, limit = 10 } = data
  return axios.get('/orders/carriers', {
    params: {
      page,
      limit,
      ...data
    }
  })
}

export function useLoadOrderCarriers(query: any) {
  return useQuery(['orderCarriers', query], () => loadOrderCarriers(query), {
    keepPreviousData: true,
    onError: () => {
      toast.error('Não foi possível carregar transportadoras', {
        toastId: 'loadOrderCarriers'
      })
    }
  })
}
